export interface IFnAppSession {
  ssPK?: number; // Selected Site PK
  sccPK: number; // Selected Cust Concept PK
  scaPK: number; // Selected Cust App PK
  saPK: number; // Selected App PK
  scPK: number; // Selected Customer PK
  scuPK: number; // Selected Cust User PK
  sauPK: number; // Selected Alta User PK
  wIndex?: number; // Wizard Index
  pid?: string; // Selected Page ID
  pmid?: string; // Parent Menu ID
  mid?: string; // Selected Menu ID implemented in FNSelectedObjSvcs
  sgaPK?: number; // Selete getstart app  PK
  baseUrl?: string;
  isSSOMultipleOrgExists?: boolean;
  smobuPK?: string;
  siteAppPK?: number;
  frnchGrpPk?: number;
  frnchUserPk?: number;
}

export class FnAppSession {
  ssPK: number;
  sccPK: number;
  scaPK: number;
  saPK: number;
  scPK: number;
  scuPK: number;
  sauPK: number;
  wIndex?: number;
  pid: string;
  pmid: string;
  mid: string;
  sgaPK: number;
  baseUrl: string;
  isSSOMultipleOrgExists?: boolean;
  smobuPK?: string;
  frnchGrpPk?: number;
  frnchUserPk?: number;

  constructor(fnSession: IFnAppSession) {
    this.ssPK = fnSession.ssPK;
    this.sccPK = fnSession.sccPK;
    this.scaPK = fnSession.scaPK;
    this.saPK = fnSession.saPK;
    this.scPK = fnSession.scPK;
    this.scuPK = fnSession.scuPK;
    this.sauPK = fnSession.sauPK;
    this.wIndex = fnSession.wIndex;
    this.pid = fnSession.pid;
    this.pmid = fnSession.pmid;
    this.mid = fnSession.mid;
    this.sgaPK = fnSession.sgaPK;
    this.baseUrl = fnSession.baseUrl;
    this.isSSOMultipleOrgExists = fnSession.isSSOMultipleOrgExists;
    this.smobuPK = fnSession.smobuPK;
    this.frnchGrpPk = fnSession.frnchGrpPk;
    this.frnchUserPk = fnSession.frnchUserPk;
  }
}
